module.exports = __webpack_public_path__ + "02_long_black.0cea613b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_long_black.png
// module id = CHsu
// module chunks = 0